<template>
  <div class="yywColor">
    <div v-for="(para, index) in paraList" :key="index">
      <span v-for="(sent, _index) in para" :key="index + '_' + _index">
        <el-popover
          v-if="sent.errorPosInfo"
          popper-class="yywColor_popover"
          placement="top-start"
          trigger="hover"
          width="400"
        >
          <div>
            <span>{{
              sent.errorPosInfo.newSubErrorType === 3
                ? '删除' + sent.errorPosInfo.orgChunk
                : sent.errorPosInfo.orgChunk + ' → ' + sent.errorPosInfo.correctChunk
            }}</span>
            <p>
              【{{ sent.errorPosInfo.errorTypeTitle }}】{{
                sent.errorPosInfo.errBaseInfo
              }}
            </p>
            <template
              v-if="
                sent.errorPosInfo.knowledgeExp ||
                (sent.errorPosInfo.exampleCases && sent.errorPosInfo.exampleCases.length)
              "
            >
              <label>语法知识点</label>
              <p v-if="sent.errorPosInfo.knowledgeExp">
                {{ sent.errorPosInfo.knowledgeExp }}
              </p>
              <div
                class="exampleCases"
                v-for="(exampleCases, index) in sent.errorPosInfo.exampleCases"
                :key="index"
              >
                <div class="flex">
                  <span
                    class="el-icon-check"
                    style="color: #00c06b; margin-right: 7px; font-weight: bold"
                  ></span>
                  <div>
                    <p>{{ exampleCases.right }}</p>
                    <p>{{ exampleCases.rightTranslate }}</p>
                  </div>
                </div>
                <div class="flex">
                  <span
                    class="el-icon-close"
                    style="color: #fb6863; margin-right: 7px; font-weight: bold"
                  ></span>
                  <p>{{ exampleCases.error }}</p>
                </div>
              </div>
            </template>
          </div>
          <span
            slot="reference"
            style="color: #fb6863; text-decoration: underline; white-space: pre-wrap"
            >{{ sent.rawSent }}</span
          >
        </el-popover>
        <span v-else>{{ sent.rawSent }}</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'yywColor',
  props: {
    result: {
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      paraList: [],
    }
  },
  methods: {
    init() {
      let paraList = []
      this.result.sentsFeedback.map((i) => {
        paraList[i.paraId] = paraList[i.paraId] || []
        if (i.errorPosInfos && i.errorPosInfos.length) {
          let last = 0
          i.errorPosInfos.forEach((item) => {
            paraList[i.paraId].push({
              rawSent: i.rawSent.slice(last, item.startPos),
            })
            paraList[i.paraId].push({
              rawSent: i.rawSent.slice(item.startPos, item.endPos),
              errorPosInfo: item,
            })
            last = item.endPos
          })
          if (last !== i.rawSegSent.length - 1) {
            paraList[i.paraId].push({
              rawSent: i.rawSent.slice(last, i.rawSegSent.length - 1),
            })
          }
        } else {
          paraList[i.paraId].push(i)
        }
      })
      this.paraList = paraList
    },
  },
  watch: {
    result(v) {
      if (v && v.sentsFeedback) {
        this.init()
      }
    },
  },
  mounted() {
  },
  destroyed() {},
}
</script>

<style lang="less">
.yywColor_popover {
  display: inline;
  background: #24cc7c!important;
  * {
    color: #fff;
  }
  .exampleCases {
    background: #eeeeee;
    border-radius: 5px;
    padding: 13px 20px;
    & + .exampleCases {
      margin-top: 10px;
    }
    * {
      color: #666;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/ui/components/yywColor/main.vue